export const getDifferenceInTime = inputDateStr => {
  // Convert the input date string to a Date object (in UTC)
  const inputDate = new Date(inputDateStr);

  // Get the current date (in local time)
  const currentDate = new Date();

  // Get the user's local timezone offset in milliseconds
  const userTimezoneOffset = currentDate.getTimezoneOffset() * 60 * 1000;

  // Function to adjust date by the user's local timezone
  const adjustToUserTimeZone = date => {
    return new Date(date.getTime() - userTimezoneOffset);
  };

  // Adjust both input date and current date to the user's local time zone
  const inputDateLocal = adjustToUserTimeZone(inputDate);
  const currentDateLocal = adjustToUserTimeZone(currentDate);

  // Calculate the difference in milliseconds
  const differenceInMs = currentDateLocal - inputDateLocal;

  // Determine if the date is expired (past)
  const isExpired = differenceInMs > 0;

  // Convert milliseconds to days, hours, minutes, and seconds
  const differenceInDays = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));
  const differenceInHours = Math.floor(
    (differenceInMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const differenceInMinutes = Math.floor(
    (differenceInMs % (1000 * 60 * 60)) / (1000 * 60)
  );
  const differenceInSeconds = Math.floor((differenceInMs % (1000 * 60)) / 1000);

  return {
    days: differenceInDays,
    hours: differenceInHours,
    minutes: differenceInMinutes,
    seconds: differenceInSeconds,
    totatTimeMS: differenceInMs,
    isExpired // true if the input date is in the past
  };
};
